import { render, staticRenderFns } from "./XimuConfirmDialog.vue?vue&type=template&id=27563ef8&scoped=true"
import script from "./XimuConfirmDialog.vue?vue&type=script&lang=js"
export * from "./XimuConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./XimuConfirmDialog.vue?vue&type=style&index=0&id=27563ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27563ef8",
  null
  
)

export default component.exports